<template>
  <div class="form-group"
    :class="{'is-invalid-group':error || errorMessage}"
  >

    <label class="form-control-label" :for="name">{{ label }}</label>

    <div class="input-group input-group-merge">
      <div class="input-group-prepend" v-if="icon">
        <span class="input-group-text">
          <feather :type="icon" class="icon-dual"></feather>
        </span>
      </div>

      <textarea
        :name="name"
        class="form-control"
        :rows="rows"
        :class="{ 'is-invalid': error || errorMessage }"
        :placeholder="placeholder"
        @input="$emit('input', $event.target.value)"
        @blur="onBlur"
        :value="value"
      >
      </textarea>

    </div>
    <div class="invalid-feedback" v-if="errorMessage">
      {{ errorMessage }}
    </div>
    <div class="text-muted" v-if="help">
      {{ help }}
    </div>
    <!-- <ul 
        class="parsley-errors-list filled" 
        v-if="error"
      >
      <li>
          <div v-if="!required">This value is required.</div>
          <div v-if="!email">This value should be a valid email.</div>
      </li>
    </ul> -->
  </div>
</template>

<script>
export default {
  props:{
    'type':String, 
    'placeholder':String, 
    'label':String, 
    'icon':String, 
    'name':String, 
    'value':String, 
    'required':Boolean, 
    'error':String, 
    'errorMessage':String, 
    'help':String, 
    'max':Number, 
    "rows": {
      type:Number,
      default:5
    }
  },
  methods:{
    onBlur(){
      let val = parseFloat(this.$props.value)
      if(this.$props.max){
        if(val > this.$props.max){
          this.$props.value = this.$props.max
        }
      }
    }
  }
}
</script>